// MUI
import { Box, Typography } from '@mui/material';

// Third party
import { Link } from 'react-router-dom';

const LoginActionButtons = () => {
  return (
    <Box id="sign-up-link" sx={{ textAlign: 'center', mt: 3 }}>
      <Typography
        variant="body2"
        component="div"
        sx={{ color: '#ffffff', mb: 1 }}
      >
        Not logged in?{' '}
        <Link
          to="/register"
          style={{ color: '#1DB0BF', textDecoration: 'none' }}
        >
          Sign up
        </Link>
      </Typography>
    </Box>
  );
};

export { LoginActionButtons };